// Amplify v6 Cognito configuration. Reads four explicit env keys
// (USER_POOL_ID, CLIENT_ID, DOMAIN, REGION) from window.environment via
// src/config/environment.ts. Idempotent: subsequent calls after a successful
// configure are no-ops. Skips configuration entirely when REACT_APP_IDP_TYPE
// is not "cognito" or any of the four Cognito env vars are empty, so
// IDM / Entra environments are unaffected.

import { Amplify } from "aws-amplify";
import { environment } from "./environment";
import { isCognitoLoginAllowed } from "./loginMethods";

let isConfigured = false;

const isPresent = (value: string | undefined): value is string => !!value;

const buildPostLoginRedirect = (): string => {
	const base = (environment.REACT_APP_BASE_PATH || "").replace(/\/$/, "");
	return base ? `${window.location.origin}${base}/` : `${window.location.origin}/`;
};

const buildPostLogoutRedirect = (): string => {
	const base = (environment.REACT_APP_BASE_PATH || "").replace(/\/$/, "");
	return `${window.location.origin}${base}/login`;
};

export const isCognitoConfigured = (): boolean => isConfigured;

export const configureAmplify = (): void => {
	if (isConfigured) return;

	if (!isCognitoLoginAllowed) return;

	const userPoolId = environment.REACT_APP_COGNITO_USER_POOL_ID;
	const userPoolClientId = environment.REACT_APP_COGNITO_CLIENT_ID;
	const domain = environment.REACT_APP_COGNITO_DOMAIN;
	const region = environment.REACT_APP_COGNITO_REGION;

	if (!isPresent(userPoolId) || !isPresent(userPoolClientId) || !isPresent(domain) || !isPresent(region)) {
		console.warn("Amplify Cognito config skipped — one or more REACT_APP_COGNITO_* values are missing.");
		return;
	}

	try {
		Amplify.configure({
			Auth: {
				Cognito: {
					userPoolId,
					userPoolClientId,
					loginWith: {
						oauth: {
							domain,
							scopes: ["openid"],
							redirectSignIn: [buildPostLoginRedirect()],
							redirectSignOut: [buildPostLogoutRedirect()],
							responseType: "code",
						},
					},
				},
			},
		});
		isConfigured = true;
	} catch (error) {
		console.error("Amplify configure failed:", error);
	}
};
